export enum ReportReasonEnum {
	EXPLICIT_CONTENT = 'EXPLICIT_CONTENT',
	FAKE_PROFILE = 'FAKE_PROFILE',
	HATE_SPEECH = 'HATE_SPEECH',
	HARASSMENT = 'HARASSMENT',
	OTHER = 'OTHER',
	SCAM = 'SCAM',
	STORE_REFUND = 'STORE_REFUND'
}
